/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DescriptionDto } from './DescriptionDto';
import type { DescriptionPredictionDto } from './DescriptionPredictionDto';
import type { RuleStatusDto } from './RuleStatusDto';
import type { TagDto } from './TagDto';

export type FullSchemaFieldDto = {
    description?: string;
    descriptionPredictions?: Array<DescriptionPredictionDto>;
    entityType: FullSchemaFieldDto.entityType;
    externalDescriptions?: Array<DescriptionDto>;
    id?: string;
    monitored?: boolean;
    name: string;
    parentDatasetFieldId?: string;
    predictedTagsWaitingForFeedback?: Array<TagDto>;
    ruleStatuses: Array<RuleStatusDto>;
    subfields?: Array<FullSchemaFieldDto>;
    tags?: Array<TagDto>;
    terms?: Array<TagDto>;
    type: string;
    typeCategory?: FullSchemaFieldDto.typeCategory | null;
    urn?: string;
};

export namespace FullSchemaFieldDto {

    export enum entityType {
        INTEGRATION = 'INTEGRATION',
        INTEGRATION_ASSETS_REFRESH_RUN = 'INTEGRATION_ASSETS_REFRESH_RUN',
        DATASOURCE = 'DATASOURCE',
        DATASOURCE_USAGE = 'DATASOURCE_USAGE',
        DATASOURCE_INGESTION_RUN = 'DATASOURCE_INGESTION_RUN',
        DATASET = 'DATASET',
        DASHBOARD = 'DASHBOARD',
        CHART = 'CHART',
        COLLECTION = 'COLLECTION',
        DATASET_FIELD = 'DATASET_FIELD',
        DAG = 'DAG',
        DAG_RUN = 'DAG_RUN',
        TRANSFORMATION = 'TRANSFORMATION',
        TRANSFORMATION_RUN = 'TRANSFORMATION_RUN',
        RULE_RUN = 'RULE_RUN',
        RULE_RUN_GROUP_DETAIL = 'RULE_RUN_GROUP_DETAIL',
        RULE_EXECUTION_SUMMARY = 'RULE_EXECUTION_SUMMARY',
        INCIDENT = 'INCIDENT',
        USER = 'USER',
        ACCESS_TOKEN = 'ACCESS_TOKEN',
        SIFFLET_RULE = 'SIFFLET_RULE',
        CONFIG = 'CONFIG',
        TAG = 'TAG',
        DOMAIN = 'DOMAIN',
        ALERTING_HOOK = 'ALERTING_HOOK',
        RULE_MONITORING_RECOMMENDATION = 'RULE_MONITORING_RECOMMENDATION',
        DATAPOINT_QUALIFICATION = 'DATAPOINT_QUALIFICATION',
        DECLARED_ASSET = 'DECLARED_ASSET',
        DECLARED_ASSET_PROPERTIES = 'DECLARED_ASSET_PROPERTIES',
        WEBHOOK = 'WEBHOOK',
        SIFFLET_AGENT = 'SIFFLET_AGENT',
        SIFFLET_AGENT_JOB = 'SIFFLET_AGENT_JOB',
        SIFFLET_AGENT_DATASOURCE_JOB = 'SIFFLET_AGENT_DATASOURCE_JOB',
        SIFFLET_AGENT_DEBUG_JOB = 'SIFFLET_AGENT_DEBUG_JOB',
        AI_METADATA_PREDICTION = 'AI_METADATA_PREDICTION',
        CUSTOM_METADATA = 'CUSTOM_METADATA',
        CUSTOM_METADATA_ENTRY = 'CUSTOM_METADATA_ENTRY',
        DATA_PRODUCT = 'DATA_PRODUCT',
        METRIC = 'METRIC',
        ASSET_UPDATE_HISTORY_ENTITY = 'ASSET_UPDATE_HISTORY_ENTITY',
        ASSET_UPDATE_HISTORY_INGESTION = 'ASSET_UPDATE_HISTORY_INGESTION',
        ASSET_USAGE = 'ASSET_USAGE',
        ASSET_USAGE_HISTORY_RECORD = 'ASSET_USAGE_HISTORY_RECORD',
        SAML_REQUEST = 'SAML_REQUEST',
        SINGLE_USE_TOKEN = 'SINGLE_USE_TOKEN',
        FORMATTED_DESCRIPTION = 'FORMATTED_DESCRIPTION',
        RULE_ROOT_CAUSE_ANALYSIS_RUN = 'RULE_ROOT_CAUSE_ANALYSIS_RUN',
        AS_CODE_WORKSPACE = 'AS_CODE_WORKSPACE',
        ALERT = 'ALERT',
        SIFFLET_RULE_MODEL_PARAMETERS = 'SIFFLET_RULE_MODEL_PARAMETERS',
        CALENDAR = 'CALENDAR',
        CONNECTION = 'CONNECTION',
        METADATA_JOB = 'METADATA_JOB',
        DATASET_MODEL_PARAMETERS = 'DATASET_MODEL_PARAMETERS',
        COLLABORATION_TOOL_ITEM = 'COLLABORATION_TOOL_ITEM',
        DBT_IMPACT_ANALYSIS_RUN = 'DBT_IMPACT_ANALYSIS_RUN',
        INGESTION_STATEMENT_CACHE = 'INGESTION_STATEMENT_CACHE',
        LINEAGE = 'LINEAGE',
        MUTATION_LINK = 'MUTATION_LINK',
        UPSTREAM_STATE = 'UPSTREAM_STATE',
        CHAT_HISTORY = 'CHAT_HISTORY',
        TEAM = 'TEAM',
        NOTIFICATION_RULE = 'NOTIFICATION_RULE',
        RECOMMENDATION_SESSION = 'RECOMMENDATION_SESSION',
        RECOMMENDATION_MONITOR = 'RECOMMENDATION_MONITOR',
        MONITOR_BILLING_EVENT = 'MONITOR_BILLING_EVENT',
        BILLING_PERIOD_SPENDING = 'BILLING_PERIOD_SPENDING',
    }

    export enum typeCategory {
        DATE = 'DATE',
        TIME = 'TIME',
        DATETIME = 'DATETIME',
        BOOLEAN = 'BOOLEAN',
        STRING = 'STRING',
        INTEGER = 'INTEGER',
        FLOAT = 'FLOAT',
        ARRAY = 'ARRAY',
        JSON = 'JSON',
        STRUCT = 'STRUCT',
        MAP = 'MAP',
        BINARY = 'BINARY',
        OTHER = 'OTHER',
    }


}
